<!-- <div class="fpassword-container">
    
    <form [formGroup]="forgotPasswrdForm" (ngSubmit)="onSubmit()">
        <div class="card-top card-head">
            <h3>Forgot Password</h3>
            <p>Please enter your registered email to receive a link for Reset password.</p>
        </div>
         <div class="form-item">
               <label for="email">Email*</label>
               <input type="email" id="email" formControlName="email" required />
               <div  class="error" *ngIf="forgotPasswrdForm.get('email')?.invalid && forgotPasswrdForm.get('email')?.touched">
               <small *ngIf="forgotPasswrdForm.get('email')?.errors?.['required']">Email is required.</small>
               </div>
         </div>
        <div class="actions">
            <button 
          type="submit" 
          class="btn-action"
          [disabled]="loadingService.isLoading('forgot-password')"
        >
        <fa-icon [icon]="['fas', 'unlock-keyhole']" class="fa-thin"></fa-icon>
        Confirm
          <app-spinner 
            *ngIf="loadingService.isLoading('forgot-password')" 
            size="small"
          ></app-spinner>
        </button>
         <a (click)="login()" class="login">Sign in?</a>
        </div>
    </form>
</div> -->

<!-- bootstrap  -->
<!-- <section class="vh-100">
   <div class="mask d-flex align-items-center h-100">
      <div class="container h-100">
         <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col-12 col-md-9 col-lg-7 col-xl-6">
               <div class="card" style="border: none;
                                 border-radius: 6px;
                                 box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
                                 max-width: 500px;">
                  <div class="card-body  p-3">
                     <div class="card-top">
                        <h3>Forgot Password</h3>
                        <p>Please enter your registered email to receive a link for Reset password.</p>
                     </div>
         
                     <form [formGroup]="forgotPasswrdForm" (ngSubmit)="onSubmit()">
                        <div class="form-group ">
                           <input type="email" id="email" formControlName="email" class="form-control" placeholder=" " required />
                           <label for="email" class="form-label">Email*</label>
                           <div  class="error" *ngIf="forgotPasswrdForm.get('email')?.invalid && forgotPasswrdForm.get('email')?.touched">
                           <small *ngIf="forgotPasswrdForm.get('email')?.errors?.['required']">Email is required.</small>
                           </div>
                         </div>
                        <div class="row mb-4">
                           <div class="col">
                              <button type="submit" class="btn btn-success">
                                 <fa-icon [icon]="['fas', 'unlock-keyhole']" class="fa-thin"></fa-icon>
                                 Confirm
                              </button>
                           </div>
                           <div class="col text-end">
                              <a role="button" (click)="login()" class="text-decoration-none">Sign In</a>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section> -->
<div class="public-page">
   <div class="public-container">
      <!-- <header class="top-header">
         <h3>Forgot Password?</h3>
         <p>Please enter your registered email to receive a link for Reset password.</p>
      </header> -->
      
      <!-- Main Content -->
      <div class="main-content">
         <div class="fp-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                <path fill="none" stroke="#a74ae1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15.362 9.065l1.32 1.32c.995.995 1.345-.84 2.734-1.07c.466-.078.877-.236 1.053-.752c.156-.456-.021-.885-.574-1.438L18.5 5.731M7.5 21a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9m3.5-8L21 3" />
            </svg>
         </div>
         <div class="header-content-fp">
            <h4>Forgot Password?</h4>
            <p>Please enter your registered email to receive a link for Reset password</p>
         </div>
         <!-- <div class="forgot-header">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M280-240q-100 0-170-70T40-480q0-100 70-170t170-70q66 0 121 33t87 87h432v240h-80v120H600v-120H488q-32 54-87 87t-121 33Zm0-80q66 0 106-40.5t48-79.5h246v120h80v-120h80v-80H434q-8-39-48-79.5T280-640q-66 0-113 47t-47 113q0 66 47 113t113 47Zm0-80q33 0 56.5-23.5T360-480q0-33-23.5-56.5T280-560q-33 0-56.5 23.5T200-480q0 33 23.5 56.5T280-400Zm0-80Z"/></svg>
            <p>Please enter your registered email to receive a link for Reset password.</p>
         </div> -->
         
         <form class="form" [formGroup]="forgotPasswrdForm" (ngSubmit)="onSubmit()">
         <div class="form-row">
               <div class="form-group">
                  <label>Email  <small>*</small></label>
                  <input type="text" placeholder="Enter Registered Email" formControlName="email">
                  <div  class="error" *ngIf="forgotPasswrdForm.get('email')?.invalid && forgotPasswrdForm.get('email')?.touched">
                     <small *ngIf="forgotPasswrdForm.get('email')?.errors?.['required']">Email is required.</small>
                  </div>
               </div>
         </div>
         
         <div class="btn-submit">
             <button type="submit"
                     [disabled]="loadingService.isLoading('forgot-password')">
                  Reset Password
                 <app-spinner
                         *ngIf="loadingService.isLoading('forgot-password')"
                         size="small"
                 ></app-spinner>
               </button>
               
         </div>
         <!-- <a (click)="login()" class="login">Sign in?</a> -->
          <div class="back-login">
            <a (click)="login()">← Back to log in</a>
          </div>
         </form>
      </div>
   </div>
</div>


<!-- <div class="container">
    <div class="icon"></div>
     <h3>Forgot Password?</h3>
      <p>Please enter your registered email to receive a link for Reset password.</p>
    <form>
      <input type="email" placeholder="Enter your email" required />
      <button type="submit">Reset password</button>
    </form>
    <a href="#" class="back-login">← Back to log in</a>
  </div> -->